// Search parameters of the runs list: malformed values are dropped, not fatal.
import { z } from "zod";
import type { RunsSearch } from "../context";

const Schema = z.object({
  agent: z
    .string()
    .regex(/^[a-z0-9](?:[-a-z0-9]{0,61}[a-z0-9])?$/)
    .optional()
    .catch(undefined),
  conversation: z.uuid().optional().catch(undefined),
});

export const validateRunsSearch = (raw: Record<string, unknown>): RunsSearch =>
  Object.fromEntries(
    Object.entries(Schema.parse(raw)).filter(([, value]) => value !== undefined),
  ) as RunsSearch;
